// deps
import styled from "styled-components";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const TITLE_WIDTH = "240px";

export const ContentContainer = styled.div`
    padding: ${(props) => props.theme.spacing.medium};
    padding-bottom: calc(var(--sab, 0px) + ${(props) => props.theme.spacing.medium});
`;

export const ImageContainer = styled.div<{ imageUrl?: string }>`
    height: 160px;
    border-radius: ${props => props.theme.cornerRadius.large};
    background-image: url(${props => props.imageUrl});
    background-size: cover;
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const TitleContainer = styled(Text)<{ isGiftingCart?: boolean }>`
    width: ${props => (props.isGiftingCart ? "100%" : TITLE_WIDTH)};
    margin-bottom: ${props => props.theme.spacing.xSmall};
`;

export const DescriptionListContainer = styled.ul`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.xSmall};
    margin-bottom: ${props => props.theme.spacing.large};
`;
